import { useState } from "react";

const TABS = [["kcet", "KCET / Engineering", "/cutoffs/cutoff-history.html"], ["medical", "Medical NEET", "/cutoffs/medical-cutoffs.html"], ["pgcet", "PGCET", "/cutoffs/pgcet-cutoffs.html"]];
const CSS = `
.actions, .back-link, #logoutBtn, [data-testid="ph-logout"], [data-testid="ph-back-dashboard"] { display: none !important; }
a.brand { pointer-events: none; }
html, body { overflow-x: hidden !important; max-width: 100vw; }
.wrap, main { max-width: none !important; width: auto !important; margin: 0 !important; padding: 16px 20px 40px !important; box-sizing: border-box; }
.wrap > *, main > * { max-width: 100%; box-sizing: border-box; }
.filters, .filter-grid { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)) !important; }
.filters *, .filter-grid * { min-width: 0; max-width: 100%; box-sizing: border-box; }
.table-wrap, .table-scroll { max-width: 100%; overflow-x: auto !important; overflow-y: hidden !important; }
.table-scroll { max-height: none !important; height: auto !important; }
`;

const inject = (e) => {
  try {
    const doc = e.currentTarget.contentDocument;
    if (!doc || doc.getElementById("crm-embed")) return;
    const s = doc.createElement("style");
    s.id = "crm-embed"; s.textContent = CSS;
    doc.head.appendChild(s);
  } catch { /* cross-origin: ignore */ }
};

export default function Cutoffs() {
  const [tab, setTab] = useState("kcet");
  const cur = TABS.find((t) => t[0] === tab);
  return (
    <div className="-m-4 sm:-m-6 lg:-m-8 flex flex-col h-[calc(100vh-4rem)] bg-white" data-testid="cutoffs-page">
      <div className="flex items-center gap-2 px-4 py-2 border-b border-slate-200 overflow-x-auto shrink-0">
        <span className="font-heading font-bold text-[#312E81] mr-2 whitespace-nowrap" data-testid="cutoffs-header">Cutoffs</span>
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`cutoff-tab-${k}`} className={`px-4 py-1.5 rounded-full text-sm font-medium border whitespace-nowrap transition-colors ${tab === k ? "bg-[#312E81] text-white border-[#312E81]" : "bg-white border-slate-200 text-slate-600 hover:border-[#4F46E5]/50"}`}>{l}</button>
        ))}
      </div>
      <iframe key={tab} src={cur[2]} title={cur[1]} onLoad={inject} className="w-full flex-1 min-h-0 border-0" data-testid="cutoff-frame" />
    </div>
  );
}
